import axios from '@axios' //eslint-disable-line

const MENTION_GROUPS = '/mention-groups'

export default {
    getMentionGroups() {
        return axios.get(MENTION_GROUPS)
    },
    getMentionGroup(uuid) {
        return axios.get(`${MENTION_GROUPS}/${uuid}`)
    },
    createMentionGroup(payload) {
        return axios.post(MENTION_GROUPS, payload)
    },
    updateMentionGroup(uuid, payload) {
        return axios.put(`${MENTION_GROUPS}/${uuid}`, payload)
    },
    archiveMentionGroup(uuid) {
        return axios.delete(`${MENTION_GROUPS}/${uuid}`)
    },
    getArchivedMentionGroups() {
        return axios.get(`${MENTION_GROUPS}/archived`)
    },
    restoreMentionGroup(uuid) {
        return axios.put(`${MENTION_GROUPS}/${uuid}/restore`)
    },
}
